





































































































































































































































































































































import { Component, Prop, Vue } from "@/shared/vuepack";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";
import ConsumerLinkedAccountAlert from "@/shared/components/accountAlert/ConsumerLinkedAccountAlert.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { accountVerificationStatusIconMap, linkedBankAccountUseStatusIconMap } from "@/shared/awesomeIconMapper";
import {
  AccountVerificationStatus,
  accountVerificationStatusDisplayMap,
  AchVerifier,
  achVerifierDisplayMap,
  Address,
  bankAccountUseDisplayMap,
  BankAccountVerificationAccountHolderResponse,
  LinkedAccountApi,
  LinkedBankAccountUse,
  LinkedBankAccountUseStatus,
  linkedBankAccountUseStatusDisplayMap,
} from "@/shared/types";
import _ from "lodash";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import moment from "moment/moment";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { convertFromUtcStringToCstString } from "@/shared/dateHelper";

@Component({
  components: {
    AccountHolderWidgetBase,
    ConsumerLinkedAccountAlert,
    GenericLoadingSpinner
  }
})
export default class ConsumerLinkedBankAccounts extends Vue {
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();
  contactInfoStore = useContactInfoStore();
  bankAccountUseDisplayMap = bankAccountUseDisplayMap;
  linkedBankAccountUseStatusIconMap = linkedBankAccountUseStatusIconMap;
  accountVerificationStatusIconMap = accountVerificationStatusIconMap;
  linkedBankAccountUseStatusDisplayMap = linkedBankAccountUseStatusDisplayMap;
  accountVerificationStatusDisplayMap = accountVerificationStatusDisplayMap;
  LinkedBankAccountUseStatus = LinkedBankAccountUseStatus;
  AccountVerificationStatus = AccountVerificationStatus;
  achVerifierDisplayMap = achVerifierDisplayMap;
  showConfirmModal = false;
  showFullAccountNumberModal = false;
  fullAccountNumberDisplay = "";
  fullAccountNumberDisplayData = null;
  isFullAccountNumberDisplayLoading = false;
  isAccountOwnerVerificationLoading = false;
  fullAccountNumberLoadingForRow = -1;
  accountBeingViewed: LinkedAccountApi = null;
  accountOwnerVerifications: BankAccountVerificationAccountHolderResponse[] = [];
  isSubmitting = false;
  bankAccountToDelete: LinkedAccountApi = null;
  showReplaceModal = false;
  showChangeTypeModal = false;
  showVerificationReviewModal = false;
  bankAccountToReplace: LinkedAccountApi = this.init();
  isAccountVerificationCallInProgress = false;
  showDeletedAccounts = false;

  linkType = [
    { text: "Checking", value: "checking" },
    { text: "Savings", value: "savings" }
  ];

  get getAccountOwnerVerificationTableHeaders () {
    return [
      { key: "label", label: "" },
      { key: "hsaBank", label: "HSA Bank" },
      { key: "bankValue", label: this.accountBeingViewed.bankName },
      { key: "score", label: "Score" }
    ];
  }

  @Prop()
  username: string;

  get title (): string {
    return this.canAdministerLinkedAccounts ? "Manage External Linked Bank Accounts" : "External Linked Bank Accounts";
  }

  listFields = [{
    key: "bankAccountName",
    thClass: "text-left",
    tdClass: "",
    label: "Account Name"
  },
    {
      key: "bankName",
      thClass: "text-left",
      tdClass: "",
      label: "Bank Name"
    },
    {
      key: "bankAccountRouting",
      thClass: "text-left pl-1",
      tdClass: "pl-1",
      label: "Routing"
    },
    {
      key: "bankAccountNumber",
      thClass: "text-left pl-1",
      tdClass: "pl-1",
      label: "Account"
    },
    {
      key: "uses",
      label: "Use",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "dateLastModified",
      label: "Last Modified",
      thClass: "text-left",
      tdClass: "text-left"
    },
    {
      key: "delete",
      label: "",
      thClass: "",
      tdClass: "text-right"
    }];
  get hasLinkedAccounts (): boolean {
    return this.bankAccountStore.linkedAccounts && this.bankAccountStore.linkedAccounts.length > 0;
  }

  get hasAnyDeletedAccounts (): boolean {
    return this.hasLinkedAccounts && _.some(this.bankAccountStore.linkedAccounts, x => x.isDeleted);
  }
  get canAdministerLinkedAccounts (): boolean {
    return this.bankAccountStore.achVerifier === AchVerifier.Finicity
      && this.bankAccountStore.canAdministerLinkedAccounts;
  }

  get canViewLinkedAccountNumbers (): boolean {
    return this.bankAccountStore.canViewLinkedAccountNumbers;
  }
  addLinkedAccount () {
    this.bankAccountToReplace = this.init();
    this.showReplaceModal = true;
  }
  replaceRowHandler (data) {
    this.bankAccountToReplace = _.cloneDeep(data.item);
    this.bankAccountToReplace.bankAccountNumber = "";
    this.showReplaceModal = true;
  }
  currentAccountType (item: LinkedAccountApi): string {
    return item.linkedBankAccountType === "savings" ? "Savings to Checking" : "Checking to Savings";
  }
  changeTypeRowHandler (item: LinkedAccountApi) {
    this.bankAccountToReplace = _.cloneDeep(item);
    this.showChangeTypeModal = true;
  }

  get allAccounts (): any[] {
    if (!this.bankAccountStore.linkedAccounts) {
      return [];
    }
    const filtered = this.showDeletedAccounts ?
        this.bankAccountStore.linkedAccounts :
        this.bankAccountStore.linkedAccounts.filter(x => x.isDeleted === false);
    return filtered
        .sort((a, b) => (a.isDeleted === b.isDeleted) ? 0 : a.isDeleted ? 1 : -1) // false items first
        .map(item => ({
          ...item,
          isEdit: false,
          isMissingUse: item.use.accountUse === LinkedBankAccountUse.Unspecified,
          name: item.bankAccountName,
          hasError: item.apiErrorMessage !== null
        }));
  }

  canChangeType (item: LinkedAccountApi) {
    return this.canAdministerLinkedAccounts
        && item.isDeleted === false
        && item.use
        && item.use.status === LinkedBankAccountUseStatus.Active;
  }
  onChangeTypeModalClose () {
    this.bankAccountToReplace = this.init();
    this.showChangeTypeModal = false;
  }
  onChangeType () {
    this.isSubmitting = true;
    this.showChangeTypeModal = false;
    if (this.bankAccountToReplace) {
      const options = {linkedAccountToReplace: this.bankAccountToReplace, username: this.username, partnerId: 0 };
      this.bankAccountStore.adminChangeLinkedAccountType(options);
    }
    this.loadLinkedBankAccounts();
    this.isSubmitting = false;
    this.bankAccountToReplace = this.init();
  }

  get userLastName () {
    return this.contactInfoStore.contactInformation.lastName;
  }
  showErrorIcon (data) {
    return data.item.verificationStatus === AccountVerificationStatus.Failed
        || data.item.use.status === LinkedBankAccountUseStatus.Unspecified
        || data.item.use.status === LinkedBankAccountUseStatus.Inactive;
  }
  onReplaceModalClose () {
    this.bankAccountToReplace = this.init();
    this.showReplaceModal = false;
  }

  get userMiddleInitial () {
    return this.contactInfoStore.contactInformation.middleInitial;
  }

  get userFirstName () {
    return this.contactInfoStore.contactInformation.firstName;
  }

  get userEmail () {
    return this.contactInfoStore.contactInformation.email;
  }

  get userPhone () {
    const phone = this.contactInfoStore.contactInformation.phoneNumber;
    const mobile = this.contactInfoStore.contactInformation.mobilePhoneNumber;
    if (phone && phone !== "") {
      return phone;
    }
    return mobile;
  }

  get userAddress () {
    const physical = this.contactInfoStore.contactInformation.physicalAddress;
    const mailing = this.contactInfoStore.contactInformation.mailingAddress;

    const formatAddress = (a: Address) => {
      let result = a.addressLine1;
      if (a.addressLine2 && a.addressLine2 !== "") {
        result += " " + a.addressLine2;
      }
      result += " " + a.city + ", " + a.state + " " + a.zip;
      return result;
    };

    if (physical) {
      return formatAddress(physical);
    }
    return formatAddress(mailing);
  }

  convertUtcDateTimeToCentral (datetime: string) {
    return convertFromUtcStringToCstString(datetime);
  }
  onReplace () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }
      this.isSubmitting = true;
      this.showReplaceModal = false;
      if (this.bankAccountToReplace) {
        const options = {linkedAccountToReplace: this.bankAccountToReplace, username: this.username, partnerId: 0 };
        this.bankAccountStore.adminReplaceLinkedAccount(options);
      }
      this.loadLinkedBankAccounts();
      this.isSubmitting = false;
      this.bankAccountToReplace = this.init();
    });
  }
  onResync () {
    this.isSubmitting = true;
    const options = { username: this.username };
    this.bankAccountStore.adminResyncLinkedAccounts(options);
    this.isSubmitting = false;
  }

  showFullAccountNumberLoadingSpinner (data) {
    return this.isFullAccountNumberDisplayLoading && this.fullAccountNumberLoadingForRow === data.index;
  }

  onViewFullAccountNumberClicked (data) {
    this.isFullAccountNumberDisplayLoading = true;
    this.fullAccountNumberLoadingForRow = data.index;
    this.bankAccountStore.getFullBankAccountNumber(data.item.linkedBankAccountId).then(result => {
      this.isFullAccountNumberDisplayLoading = false;
      this.fullAccountNumberDisplayData = data.item;
      this.fullAccountNumberDisplay = result;
      this.showFullAccountNumberModal = true;
    });
  }
  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting || this.isConsumerLinkedAccountsInErrorState;
  }
  get isConsumerLinkedAccountsInErrorState (): boolean {
    return this.bankAccountStore.isConsumerLinkedAccountsInErrorState;
  }
  deleteRowHandler (data) {
    this.bankAccountToDelete = data.item;
    this.showConfirmModal = true;
  }
  onModalClose () {
    this.bankAccountToDelete = null;
    this.showConfirmModal = false;
  }
  onConfirmDelete () {
    this.isSubmitting = true;
    this.showConfirmModal = false;
    if (this.bankAccountToDelete) {
      const options = {linkedAccountToDelete: this.bankAccountToDelete, username: this.username, partnerId: 0 };
      this.bankAccountStore.adminDeleteLinkedAccount(options);
    }
    this.loadLinkedBankAccounts();
    this.isSubmitting = false;
    this.bankAccountToDelete = null;
  }
  loadLinkedBankAccounts () {
    const args = { username: this.username, partnerId: 0 };
    this.bankAccountStore.loadLinkedBankAccountsForUser(args);
  }
  get isLoading () {
    return !this.bankAccountStore.linkedAccountsLoaded || this.isSubmitting;
  }
  get isFailed () {
    return false;
  }

  init (): LinkedAccountApi {
    return {
      bankAccountName: "",
      bankAccountNumber: "",
      bankRoutingNumber: "",
      bankName: "",
      use: null,
      linkedBankAccountId: 0,
      linkedBankAccountType: "checking",
      verificationStatus: AccountVerificationStatus.Verified,
      hasPersonalContributionSchedules: false,
      isTokenizedAccountNumber: false,
      apiErrorMessage: null,
      apiErrorStatusCode: "ok",
      apiErrorTimestamp: null,
      hasAccountOwnerVerification: false,
    };
  }

  showReviewVerificationModal (data) {
    this.showVerificationReviewModal = true;
    this.isAccountOwnerVerificationLoading = true;
    this.accountBeingViewed = data.item;

    this.bankAccountStore.getAccountOwnerVerification(data.item.linkedBankAccountId).then(items => {
      this.accountOwnerVerifications = items;
      this.isAccountOwnerVerificationLoading = false;
    });
  }

  hasAccountOwnerVerification (data) {
    return data && data.item && data.item.hasAccountOwnerVerification;
  }

  onVerificationReviewModalClose () {
    this.showVerificationReviewModal = false;
    this.isAccountOwnerVerificationLoading = false;
    this.accountBeingViewed = null;
    this.accountOwnerVerifications = [];
  }

  getAccountOwnerVerificationTableRows (owner: BankAccountVerificationAccountHolderResponse) {

    const addresses = [];
    const phones = [];
    const emails = [];

    if (owner.bankAccountVerificationAccountHolderAddresses && owner.bankAccountVerificationAccountHolderAddresses.length > 0) {
      for (const address of owner.bankAccountVerificationAccountHolderAddresses) {
        addresses.push({
          label: "Address",
          hsaBank: this.userAddress,
          bankValue: address.ownerAddress,
          score: address.ownerAddressScore
        });
      }
    }

    if (owner.bankAccountVerificationAccountHolderPhones && owner.bankAccountVerificationAccountHolderPhones.length > 0) {
      for (const phone of owner.bankAccountVerificationAccountHolderPhones) {
        phones.push({ label: "Phone", hsaBank: this.userPhone, bankValue: phone.phone, score: phone.phoneScore });
      }
    }

    if (owner.bankAccountVerificationAccountHolderEmails && owner.bankAccountVerificationAccountHolderEmails.length > 0) {
      for (const email of owner.bankAccountVerificationAccountHolderEmails) {
        emails.push({ label: "Email", hsaBank: this.userEmail, bankValue: email.email, score: email.emailScore });
      }
    }

    const fullName = this.userFirstName + " " + this.userLastName;
    return [
      { label: "Owner Name", hsaBank: fullName, bankValue: owner.ownerName, score: owner.ownerNameScore },
      { label: "First Name", hsaBank: this.userFirstName, bankValue: owner.firstName, score: owner.firstNameScore },
      {
        label: "Middle Name",
        hsaBank: this.userMiddleInitial,
        bankValue: owner.middleName,
        score: owner.middleNameScore
      },
      { label: "Last Name", hsaBank: this.userLastName, bankValue: owner.lastName, score: owner.lastNameScore },
      ...addresses,
      ...phones,
      ...emails,
    ];
  }

  get showOverrideVerificationButton () {
    return this.accountBeingViewed
        && this.accountBeingViewed.hasAccountOwnerVerification
        && this.accountBeingViewed.verificationStatus !== AccountVerificationStatus.Verified;
  }

  onOverrideVerificationClicked () {
    this.isAccountVerificationCallInProgress = true;
    this.bankAccountStore.adminOverrideVerification(this.accountBeingViewed.linkedBankAccountId).then(response => {
      this.isAccountVerificationCallInProgress = false;
      this.loadData();
      this.showVerificationReviewModal = false;
    });
  }

  loadData () {
    this.loadLinkedBankAccounts();
  }

  isAccountRowDeleted (item: LinkedAccountApi) {
    return item && item.isDeleted === true;
  }
  getFormattedDate (date?: string): string {
    if (isNullEmptyOrUndefined(date)) {
      return "";
    }
    const local = moment.utc(date).local();
    if (isNullEmptyOrUndefined(local.zoneAbbr())) {
      return `${local.format("MM/DD/YYYY hh:mma")} ${local.tz(moment.tz.guess()).zoneAbbr()}`;
    }
    return local.format("MM/DD/YYYY hh:mma z");
  }
}
